import React, { Component } from 'react';
import { NavLink, Redirect } from "react-router-dom";
import UserService from '../Services/TokenService.js';
import TokenService from '../Services/TokenService.js';
import UseTokenForm from '../Components/UseTokenForm.js';
import Cookies from 'universal-cookie';
import { withApi } from '../Providers/WebServiceProvider.js';

import logo from '../assets/images/tovertaal_logo.png';

class UseToken extends Component
{
	constructor (props) {
		super(props);

		this.state = {
			invalidToken: false,
			loaded: false,
		}

		this.tokenService = new TokenService(props.webServiceContext.getApi());
		this.userService  = new UserService(props.webServiceContext.getApi());         
	}

	useTokenSubmit = (userParams = {}) => { 
		const that = this;

		this.tokenService.use(this.props.match.params.type, this.props.match.params.token, userParams).then(function (response) {
			const data = response.data.data;

			that.props.webServiceContext.getApi().setAccessToken(data.access_token);
			that.props.webServiceContext.auth.checkIfCanLogin();
		});
	}

	componentDidMount () {
		const that = this;  

		this.tokenService.checkExistance(this.props.match.params.type, this.props.match.params.token)
			.then(function () {
				that.setState({ loaded: true });
			})
			.catch(function () {
				that.setState({ invalidToken: true, loaded: true });
			});
	}

	render () {
		if (this.state.loaded)
		{
			return (
				<div className="container">
					<div className="columns">
						<div className="column"></div>
						<div className={this.state.invalidToken ? 'column has-text-centered' : 'column'}>
							<section className="section">
	              <NavLink exact className="is-flex tovertaal-logo" style={{justifyContent: 'center' }} to="/">
	                <img src={logo} alt="Tovertaal: Localisation System" width="140" height="55" />
	              </NavLink>
							</section>
							{ this.state.invalidToken
								? ("This token is invalid and may not be used.")
								: (<UseTokenForm token={this.props.match.params.token}  onSubmit={this.useTokenSubmit} />) 
							}
						</div>
						<div className="column"></div>
					</div>
				</div>
			);
		} else {
			return ('Loading...');
		}
	}
}

export default withApi(UseToken);


// WEBPACK FOOTER //
// ./src/Pages/UseToken.js